import React from 'react';
export default function SnowTrailSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="pet-svg">
      <style>{`
        @keyframes sn-fall1 {
          0% { transform: translate(0, 0) rotate(0deg); opacity: 0; }
          10% { opacity: 0.9; }
          50% { transform: translate(-3px, 14px) rotate(90deg); opacity: 0.75; }
          90% { opacity: 0.3; }
          100% { transform: translate(2px, 30px) rotate(180deg); opacity: 0; }
        }
        @keyframes sn-fall2 {
          0% { transform: translate(0, 0) rotate(0deg); opacity: 0; }
          10% { opacity: 0.85; }
          50% { transform: translate(4px, 12px) rotate(-70deg); opacity: 0.7; }
          90% { opacity: 0.25; }
          100% { transform: translate(-1px, 28px) rotate(-160deg); opacity: 0; }
        }
        @keyframes sn-fall3 {
          0% { transform: translate(0, 0) rotate(0deg); opacity: 0; }
          10% { opacity: 0.8; }
          50% { transform: translate(-2px, 16px) rotate(60deg); opacity: 0.65; }
          90% { opacity: 0.2; }
          100% { transform: translate(3px, 32px) rotate(150deg); opacity: 0; }
        }
        @keyframes sn-drift {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-2px); }
          75% { transform: translateX(2px); }
        }
        @keyframes sn-shimmer {
          0%, 100% { opacity: 0.4; }
          50% { opacity: 0.9; }
        }
        .sn-f1 { animation: sn-fall1 3.5s ease-in-out infinite; }
        .sn-f2 { animation: sn-fall2 4.0s ease-in-out infinite 0.6s; }
        .sn-f3 { animation: sn-fall3 3.8s ease-in-out infinite 1.2s; }
        .sn-f4 { animation: sn-fall1 4.2s ease-in-out infinite 1.8s; }
        .sn-f5 { animation: sn-fall2 3.6s ease-in-out infinite 2.4s; }
        .sn-f6 { animation: sn-fall3 4.4s ease-in-out infinite 0.3s; }
        .sn-drift { animation: sn-drift 2.5s ease-in-out infinite; }
      `}</style>
      <defs>
        <radialGradient id="snGlow" cx="0.5" cy="0.5" r="0.5">
          <stop offset="0%" stopColor="white" stopOpacity="0.6" />
          <stop offset="100%" stopColor="#B3E5FC" stopOpacity="0" />
        </radialGradient>
      </defs>

      <g className="sn-drift">
        {/* Snowflake 1 - large, left */}
        <g className="sn-f1" style={{ transformOrigin: '10px 4px' }}>
          <circle cx="10" cy="4" r="3" fill="url(#snGlow)" />
          <line x1="10" y1="1" x2="10" y2="7" stroke="white" strokeWidth="0.7" strokeLinecap="round" />
          <line x1="7" y1="4" x2="13" y2="4" stroke="white" strokeWidth="0.7" strokeLinecap="round" />
          <line x1="7.9" y1="1.9" x2="12.1" y2="6.1" stroke="white" strokeWidth="0.5" strokeLinecap="round" />
          <line x1="12.1" y1="1.9" x2="7.9" y2="6.1" stroke="white" strokeWidth="0.5" strokeLinecap="round" />
          <circle cx="10" cy="4" r="0.8" fill="white" opacity="0.8" />
        </g>

        {/* Snowflake 2 - medium, right */}
        <g className="sn-f2" style={{ transformOrigin: '30px 2px' }}>
          <circle cx="30" cy="2" r="2.5" fill="url(#snGlow)" />
          <line x1="30" y1="-0.5" x2="30" y2="4.5" stroke="#E1F5FE" strokeWidth="0.6" strokeLinecap="round" />
          <line x1="27.5" y1="2" x2="32.5" y2="2" stroke="#E1F5FE" strokeWidth="0.6" strokeLinecap="round" />
          <line x1="28.2" y1="0.2" x2="31.8" y2="3.8" stroke="#E1F5FE" strokeWidth="0.4" strokeLinecap="round" />
          <line x1="31.8" y1="0.2" x2="28.2" y2="3.8" stroke="#E1F5FE" strokeWidth="0.4" strokeLinecap="round" />
          <circle cx="30" cy="2" r="0.6" fill="white" opacity="0.7" />
        </g>

        {/* Snowflake 3 - small, center */}
        <g className="sn-f3" style={{ transformOrigin: '20px 6px' }}>
          <circle cx="20" cy="6" r="2" fill="url(#snGlow)" />
          <line x1="20" y1="4" x2="20" y2="8" stroke="white" strokeWidth="0.5" strokeLinecap="round" />
          <line x1="18" y1="6" x2="22" y2="6" stroke="white" strokeWidth="0.5" strokeLinecap="round" />
          <line x1="18.6" y1="4.6" x2="21.4" y2="7.4" stroke="white" strokeWidth="0.35" strokeLinecap="round" />
          <line x1="21.4" y1="4.6" x2="18.6" y2="7.4" stroke="white" strokeWidth="0.35" strokeLinecap="round" />
        </g>

        {/* Snowflake 4 - tiny, far left */}
        <g className="sn-f4" style={{ transformOrigin: '5px 8px' }}>
          <line x1="5" y1="6.5" x2="5" y2="9.5" stroke="#B3E5FC" strokeWidth="0.5" strokeLinecap="round" />
          <line x1="3.5" y1="8" x2="6.5" y2="8" stroke="#B3E5FC" strokeWidth="0.5" strokeLinecap="round" />
          <circle cx="5" cy="8" r="0.4" fill="white" opacity="0.6" />
        </g>

        {/* Snowflake 5 - medium, center-right */}
        <g className="sn-f5" style={{ transformOrigin: '35px 10px' }}>
          <circle cx="35" cy="10" r="2.2" fill="url(#snGlow)" />
          <line x1="35" y1="7.8" x2="35" y2="12.2" stroke="white" strokeWidth="0.55" strokeLinecap="round" />
          <line x1="32.8" y1="10" x2="37.2" y2="10" stroke="white" strokeWidth="0.55" strokeLinecap="round" />
          <line x1="33.5" y1="8.5" x2="36.5" y2="11.5" stroke="white" strokeWidth="0.4" strokeLinecap="round" />
          <line x1="36.5" y1="8.5" x2="33.5" y2="11.5" stroke="white" strokeWidth="0.4" strokeLinecap="round" />
          <circle cx="35" cy="10" r="0.5" fill="white" opacity="0.7" />
        </g>

        {/* Snowflake 6 - tiny, upper-center */}
        <g className="sn-f6" style={{ transformOrigin: '16px 1px' }}>
          <line x1="16" y1="-0.5" x2="16" y2="2.5" stroke="#E1F5FE" strokeWidth="0.45" strokeLinecap="round" />
          <line x1="14.5" y1="1" x2="17.5" y2="1" stroke="#E1F5FE" strokeWidth="0.45" strokeLinecap="round" />
          <circle cx="16" cy="1" r="0.35" fill="white" opacity="0.5" />
        </g>
      </g>

      {/* Ambient shimmer dots */}
      <circle cx="14" cy="20" r="0.4" fill="white">
        <animate attributeName="opacity" values="0;0.7;0" dur="2.5s" repeatCount="indefinite" />
      </circle>
      <circle cx="26" cy="16" r="0.3" fill="#E1F5FE">
        <animate attributeName="opacity" values="0;0.6;0" dur="3s" repeatCount="indefinite" begin="0.8s" />
      </circle>
      <circle cx="32" cy="28" r="0.35" fill="white">
        <animate attributeName="opacity" values="0;0.5;0" dur="2.8s" repeatCount="indefinite" begin="1.5s" />
      </circle>
    </svg>
  );
}
